/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { ENVIRONMENT } from 'config';

/**
 * Function that converts a given string to base64url format as required by PKCE
 * @param {String} str - String to be converted
 * @returns Base64-url encoded string
 */
const base64UrlEncode = (str) =>
  str.toString('base64').replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
/**
 * Function that generates the code verifier required for PKCE
 * @returns Code verifier
 */
export const generateCodeVerifier = () => {
  let text = '';
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  //
  for (let i = 0; i < ENVIRONMENT.KC_PKCE_VERIFIER_LENGTH; i += 1) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
};
/**
 * Function that generates a code challenge by using the SHA-256 hashing algorithm on the provided verifier
 * @param {String} codeVerifier - Code verifier to be hashed
 * @returns Base64URL-encoded code challenge
 */
export const generateCodeChallenge = async (codeVerifier) => {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(codeVerifier));
  return base64UrlEncode(window.btoa(String.fromCharCode(...new Uint8Array(digest))));
};
